import { Component, AfterContentInit, ElementRef, OnInit, OnDestroy, Optional } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseFormComponent, BaseFormHeaderInfo } from '../tasks/baseFormComponent/baseForm.component';
import { of, Observable } from 'rxjs';
import { FormConfig } from '../components/forms/form.objects';
import { IncomeDTO } from '../api/bsm-dtos';
import { ResultTypeDTO } from '../api/plyca-dtos-v2';
import { DatePipe } from '@angular/common';
import { SignatureService } from '../../services/signature.service';
import { PropertyService } from '../properties/property.service';
import { I18nData } from '../api/plyca-dtos';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog/public_api';
import { MessageDTOModal } from '../components/message.component';
import { showcontentComponent } from '../components/showcontent.component';




export class IncomeModel {

  dto: IncomeDTO;
  ui: {
    isContextWork?: boolean,
    contractFolderId?: string,
    isEnableButtonFenix?: boolean,
    incidenceAnnex?: string;
  }
}

@Component({
  selector: 'income-form',
  templateUrl: '../tasks/baseFormComponent/baseForm.template.html', providers: [DatePipe]
})
export class IncomeComponent
  extends BaseFormComponent<IncomeDTO, IncomeModel>
  implements OnInit, OnDestroy, AfterContentInit {


  headerService: any;
  private identifier: string;

  private rutaInicio: string;




  constructor(
    elem: ElementRef,
    @Optional() protected activatedRoute: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private signatureService: SignatureService,
    private propertyService: PropertyService
  ) {
    super(elem);
    this.waitService.startWaiting();

    this.waitService.cancelWaiting();

    this.subscribe(this.propertyService.getProperty('FENIX_PATH'), (value: string) => { this.rutaInicio = value; });

  }

  ngAfterContentInit(): void {

  }

  getFormSettingURL(): string {
    return 'finance/financeNOLCSP.json';
  }


  close() { }

  dtoToModel(dto: IncomeDTO): Observable<IncomeModel> {
    let model = new IncomeModel();
    model.dto = dto;
    model.ui = {
      isContextWork: false
    }

    if (dto.identifier) {
      model.ui.isEnableButtonFenix = true;
    } else {
      model.ui.isEnableButtonFenix = false;
    }

    if (this.task && this.task.work) {
      model.dto = this.task.work.income;
      model.ui.contractFolderId = this.task.division.project.contractFolderId;
      if (this.task.work.income.context &&
        this.task.work.income.context.configurations &&
        this.task.work.income.context.configurations.attachedIncidence
        && this.task.work.income.context.configurations.attachedIncidence.value) {
        model.ui.contractFolderId += '-'
          + this.task.work.income.context.configurations.attachedIncidence.value;

        model.ui.incidenceAnnex = this.getIncidenceAnnex(this.task.work.income.context.configurations.attachedIncidence.value);
      }
    }


    let modelObs: Observable<IncomeModel>;
    modelObs = of(model);
    return modelObs;
  }

  modelToDTO(model: IncomeModel): IncomeDTO {

    // SE está haciendo esta conversion porque el buscador de número de previsión devuelve un masterdata
    // y lo que se está grabando es un string
    if (model.dto.provisionNumber !== undefined && model.dto.provisionNumber.description) {
      let provisionAux = model.dto.provisionNumber.description;
      model.dto.provisionNumber = {};
      model.dto.provisionNumber = provisionAux;
    }

    if (this.task) {
      this.task.work.income = model.dto;

    }
    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();

    headerInfo.titleKey = 'RESUM ECONÒMIC DE L EXPEDIENT';

    headerInfo.titleIcon = 'fas fa-envelope-open-text';

    return headerInfo;
  }

  getObjectIdentifier(): number {
    let identifier: number;
    if (this.task && this.task.work && this.task.work.income && this.task.work.income.identifier) {
      identifier = this.task.work.income.identifier;
    }
    return identifier;
  }


  getServiceURL(): string {
    return this.configuration.UserApiUrl + this.configuration.ApiVersion + '/incomes/';
  }

  initHeaderActions() {
    this.subscribe(this.headerActionsService
      .addAction('Verificar', 'fas fa-check', 'btn-primary', true)
      , (() => {
        this.validateIncome();
      }));
    this.subscribe(this.headerActionsService
      .addAction('Guardar', 'fas fa-save', 'btn-primary', true)
      , (
        () => {
          if (this.task !== undefined) {
            this.subscribe(this.saveIfValid(),

              (result: any) => {
                if ('OK' === result.identifier) {
                  this.model.ui.isEnableButtonFenix = true;
                } else {
                  this.model.ui.isEnableButtonFenix = false;
                }
                if (result.work && result.work.income && result.work.income.identifier) {
                  this.model.dto.identifier = result.work.income.identifier;
                  //Se necesita la fecha de registro para saber si pueden acceder a Fenix.
                  this.model.dto.registrationDate = result.work.income.registrationDate;
                }
                this.waitService.cancelWaiting();

              });
          }
        }));
    this.headerActionsService.addDivider();
    this.addBack();
  }


  goToDossierInfo(_income: IncomeDTO) {
    this.router.navigate(['dossierInfo/' + _income.identifier], {
    });
  }

  validateIncome() {
    this.subscribe(this.validate(), (result => {
      if (result.result === ResultTypeDTO.OK) {
        this.model.ui.isEnableButtonFenix = true;
        this.uiService.showMessage(
          "S'' ha validat correctament.",
          'Aviso',
          'errorStyle'
        );
      } else {
        this.model.ui.isEnableButtonFenix = false;
      }
    }))
  }

  protected addBack() {
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , (success => {
        this.salir();
      }));
  }

  public execCommand() {

    let error = false;
    //Valida datos obligatorios necesarios para el alta
    if (!this.model.dto.initialDate) {
      alert('La data d\'inici del contracte és una dada oblitagorio');
      error = true;
    } else if (!this.model.dto.finalDate) {
      alert('La data de fi del contracte és una dada oblitagorio');
      error = true;
    } else if (!this.model.dto.registrationDate) {
      alert('Debe grabar la ficha antes de acceder a Fenix.');
      error = true;
    }
    if (!error) {
      let fecha = new Date();
      let ruta = 'PLYCAæPLYCAæVEæXPREVCTæ1æ' + fecha.getFullYear() + 'æ1æ1æ2æ2æ';
      if (!this.model.dto.provisionNumber) {
        //Alta. Modo: modo de acceso, valor EE
        ruta += 'EE';
      } else {
        //Modificacion. Modo: modo de acceso, valor EM.
        ruta += 'EM';
      }
      //2)	Id: no se ha de informar y en su lugar se debe trasladar el valor ææ
      ruta += 'ææ';
      //3)	Contrato: dado que no se dispone del nº de registro de contrato en este dato se le pasará el nº de expediente
      //    más secuencial interno de contrato de PLYCA. Ej: 2019RH0495AC-1, 2019RH0495AC-2
      ruta += this.model.dto.project.contractFolderId;

      if (!this.model.dto.provisionNumber) {
        ruta += 'æ';
        //4)	Anexo: Anexo: nº de anexo, en contratos el valor será '00',
        //en incidencias de contrato el secuencial de nº de incidencia (2019-12/1, 2019-12/2, etc). Su longitud será de dos dígitos
        if (this.model.dto.context.configurations.attachedIncidence.value) {
          ruta += this.getIncidenceAnnex(this.model.dto.context.configurations.attachedIncidence.value) + 'æ';
        } else {
          ruta += '00æ';
        }
        //5)	CLiente: nif/cif del adjudicatario
        ruta += this.model.dto.taxIdentifier + 'æ';

        //6)	FechaCon: fecha de alta del documento del contrato
        let fechaFormat = this.datePipe.transform(this.model.dto.registrationDate, 'dd/MM/yy');
        ruta += fechaFormat + 'æ';
        //7)	FechaRev: no se ha de informar y en su lugar se debe incluir el valor æ
        ruta += 'æ';
        //8)	FechaIni: fecha de inicio del contrato
        ruta += this.datePipe.transform(new Date(), 'dd/MM/yy') + 'æ';

        //9)	FechaFin: fecha de fin del contrato
        ruta += this.datePipe.transform(this.model.dto.finalDate, 'dd/MM/yy');
      }
      this.showAlertMessage(ruta);
      this.signatureService.setOpeningAfirma(true);
      document.location.href = this.configuration.URL_BASE + 'bsm/incomes/fenix?arg=' + btoa(unescape(encodeURIComponent(ruta)));
      setTimeout(() => {
        this.signatureService.setOpeningAfirma(false);
      }, 1500)
      //alert('execCommand: ' + ruta);
    }

  }


  showContent(
    message: string | I18nData,
    titleKey?: string | I18nData,
    styleClass?: string
  ): DynamicDialogRef {
    let context = new MessageDTOModal(message, titleKey);
    // messageData: string | I18nData, titleKey?: string | I18nData) {
    // let config: any = ServiceLocator.injector.get(DynamicDialogConfig);
    let config: DynamicDialogConfig = {
      header: context.title,
      width: '50%',
      height: '50%',
      style: { overflow: 'scroll' },
      styleClass: styleClass,

      baseZIndex: 500
    };
    config['context'] = context;

    const ref = this.dialogService.open(showcontentComponent, config);
    return ref;
  }

  showAlertMessage(ruta: string) {

    ruta = this.rutaInicio !== undefined ? this.rutaInicio + ` ` + ruta : ruta;
    let msg = `En cas que no es produeixi l'obertura de FENIX realitzar els passos següents:
    <ol>
    <li>Copieu la ruta següent: ` + ruta + `</li>
    <li>Premeu la Tecla Windows i la R del teclat (tecla windows: quadrats al costat del Alt)</li>
    <li>Enganxeu la ruta que havíeu copiat + Aceptar</li>
    <li>Introduiu la previsió d'ingrés a Fenix + Aceptar</li>
    <li>Premer a Plyca el camp 'Num. Previsió Facturació FENIX' + Guardar*/</li>
    </ol>`;
    this.showContent(msg, 'Atención');
  }

  public getIncidenceAnnex(attachedIncidence: string) {
    if (attachedIncidence != null) {
      let number = attachedIncidence.substring(attachedIncidence.indexOf("/") + 1, attachedIncidence.length);
      if (number) {
        if (number.length == 1) {
          return "0" + number;
        } else if (number.length > 1) {
          return number;
        }
      }
    }
    return "";
  }
}
